/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Footer_AccountInputs */

const en_portal_footer_account = /** @type {(inputs: Portal_Footer_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pl_portal_footer_account = /** @type {(inputs: Portal_Footer_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Portal_Footer_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_footer_account = /** @type {((inputs?: Portal_Footer_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Footer_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_footer_account(inputs)
	return en_portal_footer_account(inputs)
});